<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>

        <div class="gifts-list text-center">
            <div class="search-block py-4">
                <b-container>
                    <h2 class="mb-3">{{ page_title }}</h2>
                    <div class="mb-4" v-html="content.text1"></div>
                    <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
                        <form class="pt-1 pb-3" method="get" action="/lista-de-presentes/listas/" @submit.prevent="handleSubmit(onSubmit)">
                            <div class="d-flex align-items-center mb-3 mx-auto justify-content-center">
                                <label for="type" class="mr-2">Tipo de lista:</label>
                                <select name="type" id="type" class="form-control" style="max-width: 200px;" v-model="type">
                                    <option value="">Todos</option>
                                    <option :value="type.valor" v-for="type in types" :key="type.valor" v-html="type.nome"></option>
                                </select>
                            </div>
                            <b-row>
                                <b-col md="6" class="mx-auto">
                                    <ValidationProvider name="busca" rules="required" tag="div" v-slot="{ errors, classes, required }">
                                        <div class="d-flex search">
                                            <div class="search-input">
                                                <b-form-input type="search" name="q" v-model="q" placeholder="Digite aqui"></b-form-input>
                                            </div>
                                            <div class="search-btn">
                                                <button type="submit">
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="35px" height="20px">
                                                        <path d="M 21 3 C 11.601563 3 4 10.601563 4 20 C 4 29.398438 11.601563 37 21 37 C 24.355469 37 27.460938 36.015625 30.09375 34.34375 L 42.375 46.625 L 46.625 42.375 L 34.5 30.28125 C 36.679688 27.421875 38 23.878906 38 20 C 38 10.601563 30.398438 3 21 3 Z M 21 7 C 28.199219 7 34 12.800781 34 20 C 34 27.199219 28.199219 33 21 33 C 13.800781 33 8 27.199219 8 20 C 8 12.800781 13.800781 7 21 7 Z"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                        <small v-show="errors[0]" class="text-danger">digite um termo para buscar</small>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>
                        </form>
                    </ValidationObserver>
                </b-container>
            </div>
        </div>

        <b-container>
            <div class="py-5 text-center">
                <div v-html="content.text2"></div>
            </div>
        </b-container>

    </div>
</template>

<script>
    import Breadcrumb from '~/components/Breadcrumb';
    import Sidenav from '~/components/Sidenav';
    import TextInfo from "~/components/TextInfo";
    import product from "~/mixins/product";
    import {ValidationProvider, ValidationObserver} from "vee-validate";

    export default {
        head() {
            return {
                title: this.page_title,
            }
        },
        data() {
            return {
                page_title: 'Lista de presentes',
                content: {
                    text1: '',
                    text2: ''
                },
                types: [],
                q: '',
                type: ''
            }
        },
        computed: {
            breadcrumb() {
                return [
                    {
                        name: 'Home',
                        link: '/'
                    },
                    {
                        name: this.page_title,
                        link: null
                    }
                ];
            },
        },
        components: {
            TextInfo,
            Breadcrumb,
            Sidenav,
            ValidationProvider,
            ValidationObserver,
        },
        methods: {
            async onSubmit() {
                let url = `/lista-de-presentes/listas/?`;
                if (this.q) {
                    url += `q=${encodeURIComponent(this.q)}`
                }
                if (this.type) {
                    url += `&type=${encodeURIComponent(this.type)}`
                }
                this.$router.push(url)
            }
        },
        async fetch() {
            await this.$axios.$get(`api/v1/cms/?page_alias=lista-de-presentes`).then((res) => {
                if (res.status === 'success') {
                    this.content = res.data
                }
            }).catch(function (error) {
                console.error(error);
            })

            await this.$axios.$get('?p=Controller_ecommerce_listapresentes_api_v1&metodo=listar_tipos').then((res) => {
                if (res.status === 'success') {
                    this.types = res.types
                } else {
                    console.error(res);
                }
            }).catch(function (error) {
                console.error(error);
            })
        }
    }
</script>
